import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";
import PageHeader from "../../../components/PageHeader";
import axiosInstance from "../../../utils/axiosInstance";
import { fetchDoctorProfile, registerUser, updateDoctorDetails, updateUserDetais } from "../../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import { updateDoctorData, updateUserData } from "../../../store/appSlice";
import TextAreaField from "../../../components/TextAreaField";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";

export default function EditAboutYourselfEducation() {
  pageTitle("About Yourself / Education");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData)?.id;
  const [about, setAbout] = useState("");
  const [educationalJourney, setEducationalJourney] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [doctorDetail, setDoctorDetail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorId })
      .then((res) => {
        setDoctorDetail(res?.data?.data);
        setAbout(res?.data?.data?.about_youself || "");
        setEducationalJourney(res?.data?.data.educational_journey || "");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    if (about === "") {
      toast.error("About yourself is required.");
      return;
    }

    if (educationalJourney === "") {
      toast.error("Educational Journey is required");
      return;
    }
    const payload = {
      doctor_id: doctorId,
      about_youself: about,
      educational_journey: educationalJourney,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate(-1);
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Section topMd={0} topLg={0} topXl={0} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 align-items-center justify-content-center">
          <div className="col-12 col-lg-6 g-2">
            <CommonMobileHeader canBack title={"About/Education"} />
            <p></p>
            <TextAreaField rows={3} label="About Yourself" sublabel="Explain about yourself briefly" placeholder="Enter here..." inputType={"text"} value={about} onChange={(e) => setAbout(e.target.value)} />
            <TextAreaField rows={3} label="Your Educational Journey" sublabel="Explain briefly for better idea" placeholder="Enter here..." inputType={"text"} value={educationalJourney} onChange={(e) => setEducationalJourney(e.target.value)} />
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={submitting} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
